// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1_oQ8","cls2":"SearchBar-cls2_StN SearchBar-cls1_oQ8"};